const stripeErrorMessageTc = {
  expired_card: "請輸入有效的信用卡到期年份。",
  invalid_expiry_year_past: "請輸入有效的信用卡到期年份。",
  invalid_expiry_year: "請輸入有效的信用卡到期年份。",
  invalid_expiry_month_past: "請輸入有效的信用卡到期月份。",
  invalid_expiry_month: "請輸入有效的信用卡到期月份。",
  invalid_expiry_date: "請輸入有效的信用卡到期月份及年份",
  card_declined:
    "很抱歉, 您輸入的信用卡無法在此次付款中使用, 請輸入另一張信用卡。",
  invalid_number: "請輸入有效的信用卡號碼。",
  incomplete_number: "請輸入有效的信用卡號碼。",
  incorrect_cvc: "請輸入有效的安全碼。",
  incomplete_cvc: "請輸入有效的安全碼。",
  incomplete_expiry: "請輸入有效的信用卡到期月份及年份"
};

const stripeErrorMessageEn = {
  expired_card: "Please enter valid credit card expiry year.",
  invalid_expiry_year_past: "Please enter valid credit card expiry year.",
  invalid_expiry_year: "Please enter valid credit card expiry year.",
  invalid_expiry_month_past: "Please enter valid credit card expiry month.",
  invalid_expiry_month: "Please enter valid credit card expiry month.",
  invalid_expiry_date: "Please enter valid credit card expiry date.",
  card_declined:
    "The entered credit card can not be used, please enter a new credit card. ",
  invalid_number: "Please enter valid credit card numbers.",
  incomplete_number: "Please enter valid credit card numbers.",
  incorrect_cvc: "Please enter valid security code.",
  incomplete_cvc: "Please enter valid security code.",
  incomplete_expiry: "Please enter valid credit card expiry date."
};

export { stripeErrorMessageTc, stripeErrorMessageEn };
